import { makeStyles } from "tss-react/mui";
import { Theme247 } from "../styles/Theme247";
import {
  Breadcrumbs,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import i18n from "../reducers/i18n";
import { useEffect, useState } from "react";
import { ApplyStyle as _s } from "../utils/ApplyStyle";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ScopeHeader from "../components/ScopeHeader";
import {
  createSite,
  updateSite,
  deleteSite,
  getsitesareaeqs2,
} from "../actions/objects";
import { connect, useStore } from "react-redux";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DeletePopUp from "../components/DeletePopup";
import { getItem } from "../utils/DataProtection";
import { countriesList } from "../utils/countriesList";

export default connect(({}) => ({}), {
  createSite,
  updateSite,
  deleteSite,
  getsitesareaeqs2,
})((props) => {
  const useStyles = makeStyles()((theme) => ({
    elevatedSection: {
      ...Theme247.elevatedSection,
    },
  }));


  const lang = useStore().getState().language;

  const { classes } = useStyles();

  const [siteName, setSiteName] = useState("");
  const [street, setStreet] = useState("");
  const [address, setAddress] = useState("");

  const [platz, setPlatz] = useState("");
  const [ort, setOrt] = useState("");

  const [land, setLand] = useState("");
  const [sitenodeid, setsitenodeid] = useState("");

  const location = useLocation();

  const selectedCountries = countriesList[lang] || countriesList["de"];

  const handleCreateSite = async () => {
    await props.createSite({
      lang: "de",
      name: siteName,
      city: ort,
      zipcode: platz,
      street: street,
      siteid: address,
      country: land,
      legalentitynodeid: JSON.parse(getItem("legalentitynodeid")),
    });
    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
    }, [2000]);
    navigate("/sites");
  };

  const handleEditSite = async () => {
    await props.updateSite({
      lang: "de",
      name: siteName,
      city: ort,
      zipcode: platz,
      street: street,
      siteid: address,
      country: land,
      sitenodeid: sitenodeid,
    });
    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
    }, [2000]);
    navigate("/sites?sitenodeid=" + sitenodeid);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (location.state) {
      setSiteName(location.state.name);
      setStreet(location.state.street);
      setAddress(location.state.address);
      setPlatz(location.state.zipcode);
      setOrt(location.state.city);
      setLand(location.state.country);
      setsitenodeid(location.state.nodeid);
    }
  }, [location.state]);

  const handleDelete = () => {
    props.deleteSite({ sitenodeid });
    navigate("/sites");

    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
    }, [2000]);
  };

  const [openDialogDelete, setopenDialogDelete] = useState();

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  let isEditMode = location.state && location.state.pageType === "edit";

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" className={_s(Theme247.breadcrumbs)}>
        <div
          onClick={() => {
            navigate(-1);
          }}
          style={{ color: "rgba(0, 0, 0, 0.38)", display: "flex" }}
        >
          <ArrowBackIcon size="large" />
          {i18n().backLink}
        </div>
      </Breadcrumbs>

      <ScopeHeader
        bgColor="#0E3F51"
        bgImage="../images/bg1.webp"
        txtColor="#FFFFFF"
        title="Werke"
        description="Hier verwalten Sie die Stammdaten eines Werks. Nachdem das Werk erstellt wurde können Sie Bereiche erstellen und Equipment zuordnen."
      />

      <Paper
        elevation={Theme247.elevationLow}
        className={classes.elevatedSection}
      >
        <div className="createSite">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="_title">{ isEditMode ? i18n().update_site_title : i18n().create_site_title}</div>
            <div>
              {location.state && location.state?.pageType === "edit" ? (
                <Button
                  variant="contained"
                  color="error"
                  size="large"
                  startIcon={<DeleteForeverOutlinedIcon />}
                  onClick={() => {
                    setopenDialogDelete(true);
                  }}
                  // className={_s(Theme247.submitButton)}
                  sx={{
                    width: "100%",
                    color: "rgba(255, 61, 0, 1)",
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: "4px",
                    background: "#ffffff",
                    ":hover": { color: "#ffffff" },
                  }}
                >
                  {/* {i18n.delete}
                   */}
                  Werke löschen
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>

          <Grid container spacing={2}>
            <Grid item xs={5}>
              <TextField
                sx={{ margin: "28px 0px 36px 0px" }}
                value={siteName}
                fullWidth
                onChange={(e) => {
                  setSiteName(e.target.value);
                }}
                inputProps={{
                  id: "txtf_werk_name",
                  "data-testid": "txtf_werk_name",
                }}
                label={"Name des Werks"}
                variant="outlined"
                helperText={"z.B.: Werk Oberpfaffenhofen"}
                error={siteName === ""}
              />
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={5}>
              <TextField
                fullWidth
                value={street}
                onChange={(e) => {
                  setStreet(e.target.value);
                }}
                inputProps={{
                  id: "txtf_werk_street",
                  "data-testid": "txtf_werk_street",
                }}
                label={"Straße und Hausnummer"}
                variant="outlined"
                error={street === ""}
              />
            </Grid>

            <Grid item xs={5}>
              <TextField
                fullWidth
                value={address}
                onChange={(e) => {
                  setAddress(e.target.value);
                }}
                inputProps={{
                  id: "txtf_werk_address_addon",
                  "data-testid": "txtf_werk_address_addon",
                }}
                label={"Adresszusatz (optional)"}
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Grid container spacing={3} sx={{ marginTop: "4px" }}>
            <Grid item xs={1.5}>
              <TextField
                fullWidth
                value={platz}
                onChange={(e) => {
                  setPlatz(e.target.value);
                }}
                inputProps={{
                  id: "txtf_werk_postalcode",
                  "data-testid": "txtf_werk_postalcode",
                }}
                label={"PLZ"}
                variant="outlined"
                error={platz === ""}
              />
            </Grid>

            <Grid item xs={3.5}>
              <TextField
                fullWidth
                value={ort}
                onChange={(e) => {
                  setOrt(e.target.value);
                }}
                inputProps={{
                  id: "txtf_werk_city",
                  "data-testid": "txtf_werk_city",
                }}
                label={"Ort"}
                variant="outlined"
                error={ort === ""}
              />
            </Grid>

            <Grid item xs={5}>
              <div data-testId="drpdwn_werk_country">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Land</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={land}
                    label="Age"
                    onChange={(e) => {
                      setLand(e.target.value);
                    }}
                    inputProps={{
                      id: "drpdwn_werk_country",
                    }}
                    error={land === ""}
                  >
                    {selectedCountries.map((object) => {
                      return (
                        <MenuItem value={object.code}>
                          {object.country}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            </Grid>
          </Grid>
        </div>
      </Paper>

      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
        topic="Werke"
      ></DeletePopUp>

      <Button
        variant="contained"
        onClick={() => {
          location.state && location.state.pageType === "edit"
            ? handleEditSite()
            : handleCreateSite();
        }}
        id="btn_werk_submit"
        data-testid="btn_werk_submit"
        style={{ marginBottom: "7%" }}
        disabled={siteName === "" || land === "" || ort === "" || platz === "" || street === ""}
      >
        {" "}
        {location.state && location.state.pageType === "edit"
          ? "Änderungen Speichern"
          : "Werk Bearbeitung"}
      </Button>
    </>
  );
});
